import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/product',
    name: 'Production',
    component: () => import('../views/ProductView.vue')
  },
  {
    path: '/install',
    name: 'Installation',
    component: () => import('../views/InstallView.vue')
  },
  {
    path: '/safety',
    name: 'Safety',
    component: () => import('../views/SafetyView.vue')
  },  
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        block: 'start'
      };
    }
    return savedPosition || { top: 0 };
  }  
})

export default router
